const QUERY = "(pointer: coarse)";

const query = (): MediaQueryList | null =>
  typeof window === "undefined" || typeof window.matchMedia !== "function"
    ? null
    : window.matchMedia(QUERY);

/**
 * Whether the primary pointer is coarse: a phone or a tablet, where the keyboard is on screen and
 * has no Shift+Enter. A laptop with a touch screen reports its trackpad, and is not one. This is
 * the nearest thing the platform offers to "is there a hardware keyboard", which it does not say.
 */
export const coarsePointer = {
  get: (): boolean => query()?.matches ?? false,
  subscribe(listener: () => void): () => void {
    const list = query();
    if (list === null) return () => {};
    list.addEventListener("change", listener);
    return () => list.removeEventListener("change", listener);
  },
};
